import { Modal } from "antd";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import NoDate from "shared/assets/icons/no_date.png";
// import Modal from "shared/components/Modal";
import { NAME_SPACES } from "shared/locales/constants";
import Button from "../../Components/Button";
import Header from "../../Components/Header";
import { MdArrowForward, MdOutlineEditCalendar } from "react-icons/md";

const UpdateModal = ({
  showChangeCostModal,
  insurancePlanName,
  onChangeCost,
  onCancelChangeCost,
  setShowChangeCostModal,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const CHANGE_COST = t("DETAIL.CHANGE_COST", { returnObjects: true });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const isCostExist = {
    [false]: (
      <>
        <img src={NoDate} alt="noDAte" />
        <h4 className="cost__updated--title">{CHANGE_COST.NO_COST}</h4>
        <p className="cost__updated--text">{CHANGE_COST.NO_COST_TEXT}</p>
        <div className="cost__updated--actions">
          <Button
            type="gray--outlined"
            onClick={() => setShowChangeCostModal({})}
          >
            {CHANGE_COST.CLOSE}
          </Button>
        </div>
      </>
    ),
    [true]: (
      <div className="cost__updated">
        <Header
          small
          icon={<MdOutlineEditCalendar size={isMobile ? 40 : 64 } color="#0763AE" />}
          title="Souhaitez-vous vraiment changer la date d’effet ?"
          highlight="changer la date d’effet"
        />
        <p className="cost__updated--short">Une évolution tarifaire est prévue à la nouvelle date, le tarif sera mis à jour</p>
        <div className="cost__updated--frame">
          <div className="cost__updated--cost">
            <h4>{CHANGE_COST.OLD_COST}</h4>
            <div className="cost__updated--content">
              <p className="cost__updated--content--effectiveDate">
                {`${CHANGE_COST.EFFECTIVE_DATE} : ${get(
                  showChangeCostModal,
                  "issuanceDate.old"
                )}`}
              </p>
              <div className="--info">
                <p className="cost__updated--content--insurance">
                  {insurancePlanName}
                </p>
                <p className="cost__updated--content--cost">
                  <strong>{get(showChangeCostModal, "cost.old")}</strong>{" "}
                  {CHANGE_COST.PER_MONTH}
                </p>
              </div>
            </div>
          </div>
          <MdArrowForward className="--icon"/>
          <div className="cost__updated--cost cost__updated--cost--active">
            <h4>{CHANGE_COST.NEW_COST}</h4>
            <div className="cost__updated--content cost__updated--content--active">
              <p className="cost__updated--content--effectiveDate">
                {`${CHANGE_COST.EFFECTIVE_DATE} : ${get(
                  showChangeCostModal,
                  "issuanceDate.new"
                )}`}
              </p>
              <div className="--info">
              <p className="cost__updated--content--insurance ">
                {insurancePlanName}
              </p>
              <p className="cost__updated--content--cost ">
                <strong>{get(showChangeCostModal, "cost.new")}</strong>{" "}
                {CHANGE_COST.PER_MONTH}
              </p>
              </div>
            </div>
          </div>
        </div>
        <div className="cost__updated--actions">
          <Button type="primary-light" onClick={onCancelChangeCost}>
            {CHANGE_COST.CANCEL}
          </Button>
          <Button type="primary" onClick={onChangeCost}>
              Oui, je confirme !
          </Button>
        </div>
      </div>
    ),
  };
  return (
    <Modal
      width={isMobile ? "100%" : 680 }
      // width={{
      //   xs: '98%',
      //   sm: '94%',
      //   md: '100%',
      //   lg: '100%',
      //   xl: '100%',
      //   xxl: '100%',
      // }}
      centered
      open={!isEmpty(showChangeCostModal)}
      footer={null}
      className="cost__modal"
      onCancel={() =>
        showChangeCostModal.noCost
          ? setShowChangeCostModal({})
          : onCancelChangeCost()
      }
    >{isCostExist[!showChangeCostModal.noCost]}</Modal>
  );
};

export default UpdateModal;
